import React from 'react';
import HomeTwoMain from './HomeTwoMain';
import HeaderTwo from '../../components/Header/HeaderTwo';
import Footer from '../../components/Footer';

const HomeTwoOnePage = () => {
  return (
    <>
      <HeaderTwo isOnePage />

      <HomeTwoMain />

      <Footer />
    </>
  );
};

export default HomeTwoOnePage;
